import axios from 'axios'
import { IhLogUrl, voiceUrl, cautionUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 重要视频、图片轨迹统计数量查询
export function mediasStatistics(params) {
  const url = IhLogUrl + '/medias/statistics'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('首页', '查询告警类型', res)
    }
    return Promise.resolve(res.data)
  })
}

// 对讲模块流水列表以及统计
export function recordFind(params) {
  const url = voiceUrl + '/record/find'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('首页', '查询对讲模块流水列表以及统计数据', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询告警状态一键求助类型
export function findAlertStatus(params) {
  const url = cautionUrl + '/alert/findAlertNum'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('首页', '查询告警状态一键求助类型', res)
    }
    return Promise.resolve(res.data)
  })
}
